import React from "react";
import SheetToPDF from "./SheetToPDF";
import "./PersonalizedBulk.css";

export default function PersonalizedBulkPage() {
  return <SheetToPDF />;
}
